import Vue from 'vue'
import App from './App.vue'

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
	config: {
		id: "UA-156016-28",
		params: {
			send_page_view: false
		}
	}
});

import VTooltip from 'v-tooltip'
Vue.use(VTooltip)

Vue.config.productionTip = false

new Vue({
	render: h => h(App),
}).$mount('#app')
